import type { AllowedCropTypes, ApiImageProps } from 'components/UI/Image';

export const createImage = ({
  baseUrl,
  filename,
  id,
  crop,
  originalWidth,
  title,
}: {
  baseUrl?: string;
  filename?: string;
  id?: string;
  crop?: AllowedCropTypes;
  defaultUrl?: string;
  originalWidth?: number;
  title?: string;
} = {}): ApiImageProps => ({
  id: id || '1',
  baseUrl: baseUrl || 'https://base-url/img/241/1634844972/',
  filename: filename || 'page23_robot',
  defaultUrl: 'defaultUrl',
  crop: crop || 'c16_9',
  originalWidth: originalWidth || 1160,
  originalHeight: 797,
  ...(title ? { title: title } : null),
});

export const mockMatchMedia = ({
  matches = false,
  addEventListener = jest.fn(),
  removeEventListener = jest.fn(),
}: {
  matches?: boolean;
  addEventListener?: () => void;
  removeEventListener?: () => void;
}) => {
  Object.defineProperty(window, 'matchMedia', {
    writable: true,
    value: jest.fn().mockImplementation(() => ({ matches, addEventListener, removeEventListener })),
  });
};
